/**
 * Estimaciones list
 *
 */
import { Table, message, Input, Divider, Button, Popconfirm } from 'antd'
import React from 'react'
import Api from '../../../Api'
import { Cell, Crud } from '../../../components'
import numeral from 'numeral'
import moment from 'moment'
import Exception from '../../../Exception'
import { EstimacionFormModal } from './Modal'
import _ from 'lodash'

/**
 *
 * @param {{ subContratoId?: number, search?: string }} options
 */
function queryRecords(options = {}) {
  const { search } = options
  const likeSearch = { $like: `%${search}%`}

  const e_filter = {
    iActivo: true
  }

  if (options.subContratoId) {
    e_filter.iIdSubContrato = options.subContratoId
  }

  if (search && search.length > 0) {
    e_filter.$or = [
      { sFolio: likeSearch },
      { sComentarios: likeSearch },
    ]
  }

  /*const p_filter = (!search) || (search.length === 0) ? null : {
    $or: [
      { sContrato: likeSearch },
      { sNombreCorto: likeSearch },
      { mDescripcionCorta: likeSearch },
    ]
  }*/

  return Api.query({
    model: 'SubEstimacion',
    attributes: [
      ['iId', 'id'],
      ['iIdSubContrato', 'subContratoId'],
      ['sFolio', 'folio'],
      ['sStatus', 'status'],
      ['dImporte', 'importe'],
      ['dTotal', 'total'],
      ['dPorcentajeFondoGarantia', 'porcentajeFondoGarantia'],
      ['dImporteFondoGarantia', 'importeFondoGarantia'],
      ['dPorcentajeAmortizacion', 'porcentajeAmortizacion'],
      ['dImporteAmortizacion', 'importeAmortizacion'],
      ['sComentarios', 'comentarios'],
      ['dInicio', 'inicio'],
      ['dTermino', 'termino'],
      ['dTipoCambio', 'tipoCambio'],
    ],

    include: [
      {
        as: 'moneda',
        attributes: [['sNombre', 'nombre']],
        required: true,
      },
      {
        as: 'subcontract',
        required: true,
        attributes: [
          ['sContrato', 'codigo'],
          ['sNombreCorto', 'nombre'],
        ],

        include: [{
          as: 'ordenServicio',
          required: true,
          attributes: [
            ['sConsecutivo', 'folio']
          ],
          where: {
            iId_proveedor: Api.getProviderId(),
          }
        }]
      }
    ],

    where: e_filter
  })
}

/**
 *
 * @param {{ subContratoId: number, onAdd()?: void, }} props
 */
export function EstimacionesTableList(props) {
  const [loading, setLoading] = React.useState(false)
  const [anticipoExists, setAnticipoExists] = React.useState(true)
  const [data, setData] = React.useState([])
  const [estimacion, setEstimacion] = React.useState(null)
  const [search, setSearch] = React.useState('')

  const renderCurrency = val => numeral(val).format('$0,0.00')

  const columns = Cell.buildList([
    { title: 'SUBCONTRATO', dataIndex: 'subcontract.codigo', width: 140 },
    { title: 'OS', dataIndex: 'subcontract.ordenServicio.folio', width: 90 },
    { title: 'FOLIO', dataIndex: 'folio', width: 200, render: (val, r) => (
      <span className='apply-accent-text-color' style={{ cursor: 'pointer' }} onClick={() => setEstimacion(r)}>{val}</span>
    )},
    { title: 'STATUS', dataIndex: 'status', width: 80 },
    { title: 'INICIO', dataIndex: 'inicio', width: 70, render: val => moment(val).format('D MMM YY') },
    { title: 'FIN', dataIndex: 'termino', width: 70, render: val => moment(val).format('D MMM YY') },
    { title: 'MONEDA', dataIndex: 'moneda.nombre', width: 80 },
    { title: 'IMPORTE', className: 'column-money', dataIndex: 'importe', render: renderCurrency, width: 100 },
    { title: '% FONDO GARANTÍA', className: 'column-money', dataIndex: 'porcentajeFondoGarantia', render: val => numeral(val).format('0,0.00') + '%', width: 100 },
    { title: '$ FONDO GARANTÍA', className: 'column-money', dataIndex: 'importeFondoGarantia', render: renderCurrency, width: 100 },
    { title: '% AMORT.', className: 'column-money', dataIndex: 'porcentajeAmortizacion', render: val =>  numeral(val).format('0,0.00') + '%', width: 100 },
    { title: '$ AMORT.', className: 'column-money', dataIndex: 'importeAmortizacion', render: renderCurrency, width: 100 },
    { title: '$ TOTAL', className: 'column-money', dataIndex: 'total', render: renderCurrency, width: 100 },
    { title: 'COMENTARIOS', dataIndex: 'comentarios', width: 150 },
  ])

  /**
   *
   * @param {{ subContratoId: number, search: string }} options
   */
  const fetch = (options) => {
    setLoading(true)

    queryRecords(options)
      .then(r => {
        setData(r.data)
        setSearch(options.search)
        setLoading(false)
      })
      .catch(e => {
        setLoading(false)
        message.error((new Exception(e)).toComponent())
      })
  }

  //
  const checkAnticipoCreado = async (subContratoId) => {
    try {
      const a = await Api.query({
        __returnType: 'one',
        model: 'SubEstimacion',
        attributes: ['iId'],

        // include: [{
        //   as: 'estimacion',
        //   attributes: [],
        //   where: { iActivo: true, iIdSubContrato: props.subContratoId },
        // }],

        where: {
          iActivo: true,
          iIdSubContrato: subContratoId,
          sFolio: { $like: '%ANTICIPO%' },
          // sTipoPago: 'ANTICIPO',
        }
      })

      setAnticipoExists(!!a.data)
    } catch (err) {
      alert(err.message)
    }
  }

  //
  const solicitarAnticipoSubContrato = () => {
    Api.post('/kernel/jobs/do/list', {
      items: [{
        identificador: 'subcontratos@estimacionAnticipo',
        params: [props.subContratoId],
      }]
    })
    .then(r => {
      fetch({ subContratoId: props.subContratoId })
      checkAnticipoCreado(props.subContratoId)
    }).catch(err => {
      message.error(
        (new Exception(err)).toComponent()
      )
    })
  }

  /**
   * onLoad
   *
   */
  React.useEffect(() => {
    fetch({ subContratoId: props.subContratoId })

    if (props.subContratoId) {
      checkAnticipoCreado(props.subContratoId)
    }
  }, [props.subContratoId])

  const crud = (
    <Crud
      buttons={['add', 'reload']}
      onReload={() => fetch({ subContratoId: props.subContratoId, search })}
      onAdd={() => setEstimacion({ id: 0 })}
    />
  )

  const tableTitle = (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 3 }}>
      <label>Estimaciones</label>
      <Divider type='vertical' />
      <Input.Search
        placeholder="Buscar"
        style={{ width: 185 }}
        onSearch={value => fetch({ subContratoId: props.subContratoId, search: value })}
        allowClear
      />
      <Divider type='vertical' />
      {crud}
      <Divider type='vertical' />
      {anticipoExists || !props.subContratoId ? null : (
        <Popconfirm title='Solicitar anticipo?' onConfirm={solicitarAnticipoSubContrato}>
          <Button
            key='anticipo'
            children='Sol. Anticipo'
          />
        </Popconfirm>
      )}
    </div>
  )

  return (
    <React.Fragment>
      <div style={{ flex: 1, position: 'relative' }}>
        <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', top: 0, left: 0, right: 0, bottom: 0, overflowY: 'auto' }}>
          <Table
            rowKey='id'
            size='small'
            rowClassName='row-pure'
            dataSource={data}
            columns={columns}
            loading={loading}
            pagination={false}
            title={() => tableTitle}
            bordered={true}
          />
        </div>
      </div>

      <EstimacionFormModal
        estimacionId={_.get(estimacion, 'id')}
        subcontratoId={_.get(estimacion, 'subContratoId') || props.subContratoId}
        onCancel={() => setEstimacion(undefined)}
        onSave={ne => {
          fetch({ subContratoId: props.subContratoId })
          setEstimacion(ne)
        }}
        onRemoved={() => {
          setEstimacion(undefined)
          fetch({ subContratoId: props.subContratoId })
        }}
      />
    </React.Fragment>
  )
}
